var _path, _rect, _rect2, _path2, _rect3, _rect4, _g, _rect5, _rect6, _path3, _rect7, _rect8, _g2, _rect9, _rect0, _path4, _rect1, _rect10, _path5, _rect11, _rect12, _path6, _rect13, _rect14, _path7, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInteriorFrontOverlay = function SvgInteriorFrontOverlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 724 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-driverSeat"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "interior-front-driverSeat-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M17.1165 494.909C9.78086 490.02 3.91235 488.063 0 487.783V579.025H247.945C253.813 566.115 255.933 552.454 256.259 547.238L256.748 546.749C260.66 540.88 267.181 526.698 269.952 520.34C269.561 518.775 269.789 504.691 269.952 497.844L275.82 487.085C276.212 485.912 277.614 485.944 278.266 486.107H279.244C281.591 479.456 286.09 464.752 288.046 458.232C292.741 442.191 296.197 412.099 297.338 399.058C297.729 389.277 293.915 382.267 291.959 379.985C286.873 373.725 279.407 371.834 276.309 371.671C273.18 371.28 270.441 373.138 269.463 374.116L212.245 372.16C202.855 371.769 183.554 371.671 175.077 371.671L107.59 374.115C104.851 371.377 97.6456 371.67 94.3853 372.159C81.0834 374.115 68.9551 381.777 64.5537 385.363C52.9389 396.591 44.9324 421.038 41.1962 432.446L41.0796 432.802C33.6462 455.493 33.2549 483.661 33.744 494.909H17.1165Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-driverSeat-point",
    className: "svg-interior-point"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 147.691,
    y: 438.181,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-driverSeat-text",
    x: 164.3,
    y: 459.569,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147.691,
    y: 438.181,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-passengerSeat"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "interior-front-passengerSeat-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M706.678 494.913C714.894 489.436 721.512 488.066 723.794 488.066L723.794 579.029H475.849C469.198 562.597 467.535 551.317 467.535 547.73C464.014 543.427 456.94 527.354 453.842 519.855V497.359L447.485 486.6C447.093 485.818 445.692 485.948 445.04 486.111C439.953 475.939 435.096 456.116 433.302 447.477C428.901 423.514 427.923 415.2 426.945 406.397C424.598 389.965 429.364 382.527 433.461 377.995C437.018 374.051 441.701 372.771 445.18 372.096C450.698 371.024 453.842 373.142 454.331 374.12L492.966 372.652C529.351 371.087 550.836 371.674 557.031 372.163L616.205 374.119C619.335 370.598 630.224 372.326 635.277 373.63C646.232 375.978 654.839 381.781 657.773 384.389C664.424 388.693 671.956 404.44 674.89 411.776C681.932 425.86 686.627 447.965 688.094 457.257C690.05 467.037 690.213 486.436 690.05 494.913H706.678Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-passengerSeat-point",
    className: "svg-interior-point"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 542.848,
    y: 438.185,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-passengerSeat-text",
    x: 559.5,
    y: 459.573,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 542.848,
    y: 438.185,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-carpet"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interior-front-carpet-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.044 337.434L427.913 387.317C430.358 380.475 434.433 376.72 436.227 375.578C440.53 372.448 446.391 371.747 448.362 371.747C451.609 371.747 454.321 373.459 454.321 374.111C500.878 371.764 542.838 370.688 560.443 372.155L615.705 374.111C621.574 369.227 638.038 373.785 644.559 376.556L627.442 343.301C623.139 335.477 616.194 331.238 613.26 330.097C598.784 323.838 566.475 320.317 552.13 319.34C502.736 316.899 454.81 317.385 436.716 319.34C431.629 320.122 427.424 323.252 425.957 324.719C422.436 327.066 421.881 334.174 422.044 337.434Z",
    fill: "#FFA928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3196 341.84L79.225 376.562C88.3312 372.759 94.0156 372.245 94.8453 372.086C102.905 371.204 106.447 372.88 107.639 374.042L155.548 372.351C182.906 371.084 197.475 371.838 208.397 372.001L269.463 374.117C272.852 370.643 276.963 371.474 280.2 372.316C285.401 373.905 289.353 377.019 290.82 378.649C293.883 381.71 295.382 386.017 295.871 387.811C296.654 385.463 300.109 351.295 301.74 334.505C301.348 327.463 297.99 323.746 296.36 322.767C290.1 318.855 279.081 318.203 274.353 318.366L200.019 318.855C181.631 318.855 161.384 320.485 153.56 321.3C128.129 323.256 113.295 328.636 109.057 331.081C102.797 333.429 98.6237 339.232 97.3196 341.84Z",
    fill: "#FFA928"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-carpet-point",
    className: "svg-interior-point"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 521.32,
    y: 328.637,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-carpet-text",
    x: 538,
    y: 350.024,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 521.32,
    y: 328.637,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-steeringWheel"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "interior-front-steeringWheel-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.793 153.069C205.12 153.399 239.631 163.341 255.77 198.063C261.638 209.311 270.441 237.675 254.792 267.018C249.863 274.397 239.142 294.404 207.843 303.696L205.398 305.163C197.084 305.652 181.924 305.675 173.121 305.163L170.676 303.696C161.384 301.251 145.773 295.362 132.079 280.691C126.602 274.822 112.578 257.494 111.013 229.325C110.524 218.403 113.947 191.669 134.976 172.596C142.312 165.913 161.384 152.567 187.793 153.069ZM132.531 232.747C130.901 234.051 127.641 235.192 127.152 231.28C126.76 219.933 130.901 207.644 133.02 202.918C137.715 191.573 146.436 183.649 152.093 179.931C169.209 168.683 183.881 169.175 189.749 169.662C205.399 170.053 219.092 178.301 223.982 182.376C232.981 188.245 239.795 200.145 242.077 205.361C247.163 217.098 248.108 224.923 247.945 227.368C248.337 230.889 248.108 232.748 247.945 233.237C247.554 234.019 246.478 233.889 245.989 233.726L243.544 231.281C238.067 225.021 233.437 222.804 231.807 222.478C231.416 221.304 230.34 221.011 229.851 221.011C229.851 219.952 229.187 219.344 228.938 219.115C228.911 219.091 228.889 219.07 228.873 219.055C227.405 218.402 224.373 217.098 223.982 217.098H216.647C211.56 212.795 202.953 212.734 199.53 212.696C188.771 212.734 181.761 214.979 179.968 216.609L160.896 217.098L156.494 219.054C155.712 219.445 155.842 220.521 156.005 221.01C153.658 221.401 153.397 221.825 153.56 221.988C148.865 222.38 137.585 229.324 132.531 232.747ZM216.157 265.062C213.418 272.104 211.43 281.689 210.778 285.602C220.167 282.472 230.013 273.213 233.763 268.974C237.284 265.453 242.076 256.096 244.033 251.858C243.544 247.456 240.12 243.544 237.675 241.099C237.462 241.099 236.084 240.906 234.451 240.678L234.45 240.678C233.079 240.486 231.529 240.269 230.339 240.121C227.21 242.077 225.123 244.522 224.471 245.5C223.688 245.891 218.602 258.704 216.157 265.062ZM170.187 286.58C169.372 276.147 165.297 251.955 157.472 240.61H145.735C141.007 241.751 131.748 245.598 132.531 251.858C135.628 260.334 147.887 279.538 170.187 286.58Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-steeringWheel-point",
    className: "svg-interior-point"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 173.121,
    y: 220.07,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-steeringWheel-text",
    x: 189.75,
    y: 241.457,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 173.121,
    y: 220.07,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-cockpit"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "interior-front-cockpit-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.575 153.676C128.618 163.457 130.412 172.749 131.553 176.172C139.769 167.174 153.234 160.36 158.939 158.077C175.371 151.426 194.802 153.35 202.464 155.143C229.068 160.62 247.456 181.878 253.324 191.821L527.189 190.843C549.489 190.452 567.779 188.072 574.137 186.931C581.57 185.757 586.689 182.53 588.319 181.062C592.623 177.933 594.025 170.63 594.188 167.369C594.579 156.806 591.742 143.08 590.275 137.538C589.102 134.017 586.852 132.484 585.874 132.158C580.397 130.202 572.833 129.061 569.735 128.735C560.346 127.17 525.232 126.894 480.73 125.801C436.227 124.707 238.164 125.801 238.164 125.801C235.425 125.409 196.595 126.616 177.523 127.268C165.786 127.659 152.093 129.061 146.713 129.713C142.018 130.495 138.562 131.669 137.421 132.158C135.074 133.332 133.509 137.864 133.02 139.983L130.575 153.676Z",
    fill: "#FFA928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.946 169.711C163.341 171.276 149.647 180.458 145.246 185.837C161.384 190.728 209.311 191.225 232.785 191.217C224.96 180.653 212.897 175.087 207.843 173.624C199.041 169.699 186.489 169.222 180.946 169.711Z",
    fill: "#FFA928"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-cockpit-point",
    className: "svg-interior-point"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 345.265,
    y: 141.824,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-cockpit-text",
    x: 361.9,
    y: 163.211,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 345.265,
    y: 141.824,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-coverFrontRightDoor"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "interior-front-coverFrontRightDoor-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M664.121 152.58C662.556 151.406 662.49 150.461 662.653 150.135L657.763 147.201C655.024 158.938 657.274 172.957 658.741 178.499L655.318 182.901L650.916 191.215C651.308 196.692 652.71 200.017 653.362 200.995C651.014 211.95 643.255 223.165 639.668 227.404C638.886 228.969 634.778 269.461 632.822 289.512C630.083 309.465 630.377 315.432 630.866 315.921C631.257 321.398 633.963 328.636 635.267 331.57C638.006 338.612 654.014 363.195 661.675 374.606C682.215 404.926 723.393 465.568 723.784 465.568C724.175 465.568 723.947 288.534 723.784 200.017L664.121 152.58Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-coverFrontRightDoor-point",
    className: "svg-interior-point"
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 664.121,
    y: 272.885,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-coverFrontRightDoor-text",
    x: 680.75,
    y: 294.272,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 664.121,
    y: 272.885,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-coverFrontLeftDoor"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "interior-front-coverFrontLeftDoor-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M68.9551 363.846L0 465.567V199.528L58.1961 154.047L61.1304 151.112C61.5216 150.721 61.2934 149.971 61.1304 149.645L65.5318 146.711C69.0529 154.144 66.0208 170.674 65.0427 178.499C67.3902 180.064 70.9113 187.465 72.3784 190.725C72.7696 193.855 71.2373 198.876 70.4222 200.995C71.2047 211.167 79.8771 222.513 84.1154 226.914L90.962 286.088C92.9182 299.781 93.0812 312.008 92.9182 316.409C92.9182 321.495 90.31 327.983 89.0059 330.591L85.0935 338.416L68.9551 363.846Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-coverFrontLeftDoor-point",
    className: "svg-interior-point"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3646,
    y: 257.235,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-coverFrontLeftDoor-text",
    x: 45,
    y: 278.623,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3646,
    y: 257.235,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-coverLeftPillar"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "interior-front-coverLeftPillar-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M98.2977 156.004C112.969 137.909 122.913 127.802 127.64 124.216L105.144 129.595C98.8845 130.769 94.3853 128.78 92.9182 127.639L80.6921 119.325C69.7376 112.674 53.6317 104.817 46.9482 101.72C25.8215 92.3301 6.84661 89.6567 0 89.4937V116.88C11.737 116.88 25.7563 121.444 31.2988 123.727C37.1673 125.683 53.9578 135.627 61.6194 140.354C64.7493 142.31 66.5099 148.342 66.9989 151.113C68.1509 155.721 66.0993 170.757 65.0982 178.093L65.0427 178.5C65.434 178.891 66.5099 179.478 68.466 182.901L69.9332 179.967C73.8455 170.186 90.473 159.916 98.2977 156.004Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-coverLeftPillar-point",
    className: "svg-interior-point"
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3646,
    y: 96.8295,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-coverLeftPillar-text",
    x: 45,
    y: 118.217,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3646,
    y: 96.8295,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-coverRightPillar"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "interior-front-coverRightPillar-overlay",
    className: "svg-interior-overlay",
    opacity: 0.3,
    d: "M624.997 156.004C643.777 164.219 653.362 176.054 655.318 182.901L658.741 178.5C655.807 168.23 656.296 157.96 656.785 153.069C657.274 148.668 657.437 147.853 658.252 145.734C659.426 142.995 662.328 140.68 663.632 139.865C689.062 121.477 714.329 116.88 723.784 116.88V89.4937C721.045 89.4937 710.58 91.4498 705.689 92.4279C687.693 95.949 670.152 104.328 663.632 108.077C653.46 113.163 636.245 123.89 628.91 128.617C626.171 130.182 620.922 129.921 618.64 129.595L596.144 124.216C609.446 135.953 620.922 150.298 624.997 156.004Z",
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-coverRightPillar-point",
    className: "svg-interior-point"
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 664.121,
    y: 96.8295,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-coverRightPillar-text",
    x: 680.75,
    y: 118.217,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 13.6932,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 664.121,
    y: 96.8295,
    width: 33.2549,
    height: 33.2549,
    rx: 16.6275,
    stroke: "white",
    strokeWidth: 1.95617
  })))), /*#__PURE__*/React.createElement("g", {
    id: "interior-front-other"
  }, /*#__PURE__*/React.createElement("g", {
    id: "interior-front-other-point",
    className: "svg-interior-point"
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 506.027,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FFA928"
  })), /*#__PURE__*/React.createElement("text", {
    id: "interior-front-other-text",
    x: 56,
    y: 528.118,
    textAnchor: "middle",
    fill: "#05072C",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, "0"), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 506.027,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })))));
};
export default SvgInteriorFrontOverlay;